export default class {

    // @ngInject
    constructor($routeParams, $location, responseHandler, authService) {
        this.$location = $location;
        this.responseHandler = responseHandler;
        this.authService = authService;
        this.data = {
            uid: $routeParams.uidb36,
            token: $routeParams.key,
            password1: undefined,
            password2: undefined
        };
    }

    submit() {
        let promise = this.authService.confirmReset(this.data);
        this.responseHandler(promise, 'setting your password')
            .then(() => this.$location.path('/password/reset/changed'));
    }
}



// WEBPACK FOOTER //
// ./password/reset-from-key/reset-from-key-ctrl.js